// import { 
//   HomeIcon, 
//   ChartBarIcon, 
//   UsersIcon, 
//   ShoppingBagIcon,
//   Cog6ToothIcon ,
//   DocumentTextIcon
// } from "@heroicons/react/24/outline";

// const menuItems = [
//   { Icon: HomeIcon,        label: "Dashboard",  to: "/admin/dashboard" },
//   { Icon: DocumentTextIcon, label: "Blogs",      to: "/admin/blogs" },
//   { Icon: UsersIcon,       label: "Users",      to: "/admin/users" },
// ];

// export default function Sidebar() {
//   return (
//     <aside className="sidebar">
//       <div className="logo">AdminPanel</div>
//       <nav>
//         <ul className="nav-menu">
//           {menuItems.map((item) => (
//             <li key={item.to} className="nav-item">
//               <a
//                 href={item.to}
//                 className={`nav-link ${window.location.pathname === item.to ? "active" : ""}`}
//               >
//                 <item.Icon style={{ width: "20px", height: "20px", marginRight: "12px" }} />
//                 <span className="nav-text">{item.label}</span>
//               </a>
//             </li>
//           ))}
//         </ul>
//       </nav>
//     </aside>
//   );
// }

import { 
  HomeIcon, 
  UsersIcon, 
  PowerIcon,
  DocumentTextIcon
} from "@heroicons/react/24/outline";
import { NavLink,useNavigate } from "react-router-dom"; // Better than <a href> for React

const menuItems = [
  { Icon: HomeIcon,        label: "Dashboard",  to: "/admin/dashboard" },
  { Icon: DocumentTextIcon, label: "Blogs",      to: "/admin/blogs" },
];

export default function Sidebar({ children }) {
    const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };
  return (
    <div>
      <aside className="sidebar">
        <div className="logo">AdminPanel</div>
        <nav>
          <ul className="nav-menu">
            {menuItems.map((item) => (
              <li key={item.to} className="nav-item">
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                >
                  <item.Icon style={{ width: "20px", height: "20px", marginRight: "12px" }} />
                  <span className="nav-text" >{item.label}</span>
                </NavLink>
              </li>
            ))}
             <li  className="nav-item">
                <a
                   onClick={handleLogout}
                  className="nav-link cursor-pointer"
                >
                  <PowerIcon style={{ width: "20px", height: "20px", marginRight: "12px" }} />
                  <span className="nav-text" >logout</span>
                </a>
              </li>
            {/* <li className="nav-link" style={{ width: "20px", height: "20px", marginRight: "12px" }}><a><PowerIcon/>logout</a></li> */}
          </ul>
        </nav>
      </aside>

      <div className="main-content">
        {children}
      </div>
    </div>
  );
}